import ApiAuth from "../../../api/auth";
import {
  decodeRequestOptions,
  encodeAssertion,
  decodeCreationOptions,
  encodeAttestation,
} from "./webauthn";

export function assertPasskeyEnv() {
  if (!window.PublicKeyCredential || !navigator.credentials) {
    const e = new Error("PASSKEY_NOT_SUPPORTED");
    e.code = "PASSKEY_NOT_SUPPORTED";
    throw e;
  }

  const isSecure =
    window.isSecureContext ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (!isSecure) {
    const e = new Error("PASSKEY_SECURE_REQUIRED");
    e.code = "PASSKEY_SECURE_REQUIRED";
    throw e;
  }
}

// ===== Login with passkey =====
export async function loginWithPasskey({ projectId }) {
  assertPasskeyEnv();

  const optRes = await ApiAuth.passkeyLoginOptions({ projectId });
  const { challengeId, publicKey } = optRes.data || {};
  if (!challengeId || !publicKey) throw new Error("PASSKEY_BAD_OPTIONS");

  const decoded = decodeRequestOptions(publicKey);

  const cred = await navigator.credentials.get({ publicKey: decoded });
  if (!cred) throw new Error("PASSKEY_NO_CREDENTIAL");

  const assertion = encodeAssertion(cred);

  // LF360-1970: the cookie route. The answer carries no token by design — the
  // session is set on the response, and the caller reads who it belongs to the
  // same way a reload does.
  const verifyRes = await ApiAuth.passkeyLoginVerifyWithCookie({ challengeId, assertion });
  if (!verifyRes.data?.success) throw new Error("PASSKEY_VERIFY_FAILED");

  return { ok: true };
}

// ===== Register passkey (must be logged in) =====
export async function registerPasskey() {
  assertPasskeyEnv();

  const res = await ApiAuth.passkeyRegisterOptions();
  const { options, challengeId } = res.data || {};
  if (!options || !challengeId) throw new Error("PASSKEY_BAD_REGISTER_OPTIONS");

  const decoded = decodeCreationOptions(options);
  console.log('[passkey] decoded creation options', {
    challengeType: typeof decoded.challenge,
    userId: decoded.user?.id,
  });
  console.log('[passkey] register options', { options, challengeId });
  const cred = await navigator.credentials.create({ publicKey: decoded });
  console.log('[passkey] created credential', cred);
  if (!cred) throw new Error("PASSKEY_NO_CREDENTIAL");

  const attestation = encodeAttestation(cred);

  await ApiAuth.passkeyRegisterVerify({ challengeId, attestation });

  return { ok: true };
}